import { DATA_SERVICES } from './data-services';
import { UTILITY_SERVICES } from './utilityServices';

export * from './local-storage/local-storage.service';
export * from './session';
export * from './xprt-data/xprt-data.service';
export * from './dm-data/dm-data.service';
export * from './modal-notification/modal-notification.service';
export * from './item-count/item-count.service';
export * from './post-message';
export * from './state';
export * from './transfer-data';

export const SERVICE_PROVIDERS: any[] = [
  ...DATA_SERVICES,
  ...UTILITY_SERVICES,
  { provide: 'UtilityServices', useValue: UTILITY_SERVICES },
  { provide: 'DataServices', useValue: DATA_SERVICES },
];
